import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=dca4425e&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=js&"
export * from "./Course.vue?vue&type=script&lang=js&"
import style0 from "./Course.vue?vue&type=style&index=0&id=dca4425e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca4425e",
  null
  
)

export default component.exports